module.exports = __webpack_public_path__ + "e148b4c54d746b504d17b2e7089fa032.otf";